import styled from 'styled-components';
import { ToastFlavour } from '../../types';
import Button from '../Button/Button';

type ToastWithButtonProps = {
  message: string;
  buttonText: string;
  flavour?: ToastFlavour;
  analyticsId?: string;
  onClick?: () => void;
};

const map: Record<ToastFlavour, string> = {
  custom: 'black',
  error: 'red',
  info: 'blue',
  promise: 'black',
  success: 'black',
  warning: 'black',
};

export function ToastWithButton(props: ToastWithButtonProps) {
  const { message, buttonText, flavour = 'success', analyticsId } = props;

  return (
    <Wrapper>
      <Message>{message}</Message>
      <Actions>
        <Button
          analytics
          analyticsId={analyticsId}
          color={map[flavour]}
          size='sm'
          variant=''
          onClick={props.onClick}
        >
          {buttonText}
        </Button>
      </Actions>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 10px 0;
`;

const Message = styled.p`
  margin: 0;
  padding-right: 16px;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: 14px;
`;
